import React from "react";

const Diamond = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            className="u_fill"
            d="m25.551 12.093-5.963 18.822L34 12.093h-8.449ZM6.646 5.435l-4.578 5.476H9.85L6.646 5.435Zm22.708 0-3.205 5.476h7.783l-4.578-5.476Zm-18.905 6.658H2l14.412 18.822-5.963-18.822ZM19.432 5l5.56 5.542L28.235 5h-8.803ZM7.765 5l3.243 5.542L16.568 5H7.764Zm3.927 7.093L18 32l6.308-19.907H11.692ZM18 5.245l-5.685 5.666h11.37L18 5.245Z"
        />
    </svg>
);

export default Diamond;
